export default __webpack_public_path__ + "static/1-c15ba21de5c58cff63cfe52dcebadfa3.webp";